module.exports = __webpack_public_path__ + "img/customer-service.8db23603.png";